import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=f661c238&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"
import style0 from "./StockList.vue?vue&type=style&index=0&id=f661c238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f661c238",
  null
  
)

export default component.exports